<script setup lang="ts">
import { AppSelect } from '@shared/ui/selects'

import {
  useSelectActivationType,
} from '../../../../model/additional-info/support/info-manual-activation/select-activation-type.hook'

defineOptions({
  name: 'SelectActivationType',
})

const {
  placeholder,
  model,
  options,
} = useSelectActivationType()
</script>

<template>
  <AppSelect
    v-model="model"
    :options="options"
    :placeholder="placeholder"
  />
</template>
